import { asAbortSignal } from './abortSignal';

export async function searchUsAddresses(query, { signal, limit = 6 } = {}) {
  const trimmed = String(query || '').trim();
  if (trimmed.length < 3) return [];

  const params = new URLSearchParams({
    q: trimmed,
    limit: String(limit),
  });

  const response = await fetch(`/api/address/search?${params.toString()}`, {
    signal: asAbortSignal(signal),
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Address search failed');
  }

  const data = await response.json();
  return Array.isArray(data?.results) ? data.results : [];
}
